<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">{{ showReviewStatus ? 'Business Address' : 'Business Information' }}</h5>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="address1" class="field-label">Street Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="address1"
          matInput
          type="text"
          placeholder="123 Main Street"
          class="user-record-field-input"
          formControlName="address1" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('address1')" />
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="city" class="field-label">City</label>
      <mat-form-field class="provider-fields">
        <input
          id="city"
          matInput
          type="text"
          placeholder="City"
          class="user-record-field-input"
          formControlName="city" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('city')" [customErrorMessages]="cityErrorMessages"/>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="state" class="field-label">State</label>
      <mat-form-field class="provider-fields">
        <input
          id="state"
          matInput
          type="text"
          placeholder="State"
          class="user-record-field-input"
          formControlName="state"
          [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
            <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('state')"/>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="zip" class="field-label">Zip Code</label>
      <mat-form-field class="provider-fields">
        <input
          id="zip"
          matInput
          type="text"
          maxlength="5"
          placeholder="12345"
          class="user-record-field-input"
          formControlName="zip"
          [attr.aria-describedby]="formGroup.get('zip')?.invalid && formGroup.get('zip')?.touched ? 'zip-error' : null" />
      </mat-form-field>
       <cfi-form-inline-error [control]="formGroup.get('zip')"/>
    </div>
  </div>
  @if (isNorthCarolina()) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="county" class="field-label">County</label>
        <mat-form-field class="provider-fields">
          <input
            id="county"
            matInput
            type="text"
            placeholder="County"
            class="user-record-field-input"
            formControlName="county"
            [matAutocomplete]="countyAuto" />
          <mat-autocomplete #countyAuto="matAutocomplete">
            @for (county of filteredCounties | async; track county.name) {
              <mat-option [value]="county.name">{{ county.name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('county')"/>
      </div>
    </div>
  }
  @if (!showReviewStatus) {
    <div class="provider-section-field half-width">
      <div class="user-record-field-wrapper">
        <label for="businessEmail" class="field-label">Email Address</label>
        <mat-form-field class="provider-fields">
          <input
            id="businessEmail"
            matInput
            type="text"
            placeholder="Business email"
            class="user-record-field-input"
            formControlName="businessEmail" />
        </mat-form-field>
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="businessPhone" class="field-label">Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="businessPhone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            placeholder="(123) 456-7890"
            class="user-record-field-input"
            formControlName="businessPhone"
            [dropSpecialCharacters]="false"
            [attr.aria-describedby]="formGroup.get('businessPhone')?.invalid && formGroup.get('businessPhone')?.touched ? 'businessPhone-error' : null" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('businessPhone')"/>
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="businessSecondaryPhone" class="field-label">Secondary Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="businessSecondaryPhone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            placeholder="(123) 456-7890"
            class="user-record-field-input"
            formControlName="businessSecondaryPhone"
            [dropSpecialCharacters]="false" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('businessSecondaryPhone')"/>
      </div>
    </div>
  }
</div>
